import { render, staticRenderFns } from "./Fincas.vue?vue&type=template&id=0869d3f2"
import script from "./Fincas.vue?vue&type=script&lang=js"
export * from "./Fincas.vue?vue&type=script&lang=js"
import style0 from "./Fincas.vue?vue&type=style&index=0&id=0869d3f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports